(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react', 'react-emotion', '../elements/typography', '../styles/colors'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react'), require('react-emotion'), require('../elements/typography'), require('../styles/colors'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.react, global.reactEmotion, global.typography, global.colors);
    global.Tag = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _react, _reactEmotion, _typography, _colors) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var _react2 = _interopRequireDefault(_react);

  var _colors2 = _interopRequireDefault(_colors);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n        display: inline-block;\n        background-color: ', ';\n        border-radius: 34.5px !important;\n        padding: 0.5rem 1rem !important;\n      '], ['\n        display: inline-block;\n        background-color: ', ';\n        border-radius: 34.5px !important;\n        padding: 0.5rem 1rem !important;\n      ']);

  var Tag = function Tag(_ref) {
    var categoryName = _ref.categoryName,
        className = _ref.className;
    return _react2.default.createElement(
      'div',
      {
        className: (0, _reactEmotion.cx)((0, _reactEmotion.css)(_templateObject, _colors2.default.platinum), className)
      },
      _react2.default.createElement(
        _typography.Note,
        null,
        categoryName
      )
    );
  };

  exports.default = Tag;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/elements/Tag.js
// module id = 825
// module chunks = 1